import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { Preview } from "../../../../helpers/ui/FileInput";
import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import moment from "moment";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {};
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
            });
            console.log(response);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="skp3k" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Detail SK PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Detail SK PPPK
                  </CardSubtitle>
                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3">Nama Pejabat Penetap</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .decree_p3k_signatories_official_name !== ""
                            ? this.state.detail
                                .decree_p3k_signatories_official_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">NIP Pejabat Penetap</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .decree_p3k_signatories_official_nip !== ""
                            ? this.state.detail
                                .decree_p3k_signatories_official_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">No Surat Keputusan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_decree_number !== ""
                            ? this.state.detail.decree_p3k_decree_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Surat Keputusan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_decree_date !== ""
                            ? this.dateParse(
                                this.state.detail.decree_p3k_decree_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Terhitung Mulai Tanggal</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_decree_tmt !== ""
                            ? this.dateParse(
                                this.state.detail.decree_p3k_decree_tmt
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">No Diklat Prajabatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_training_number !== ""
                            ? this.state.detail.decree_p3k_training_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">
                      Tanggal Diklat Prajabatan
                    </label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_training_date !== ""
                            ? this.dateParse(
                                this.state.detail.decree_p3k_training_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">No Surat Uji Kesehatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_health_test_number !==
                          ""
                            ? this.state.detail.decree_p3k_health_test_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">
                      Tanggal Surat Uji Kesehatan
                    </label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.decree_p3k_health_test_date !== ""
                            ? this.dateParse(
                                this.state.detail.decree_p3k_health_test_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Golongan Ruang</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.rank_name !== ""
                            ? this.state.detail.rank_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Dokumen</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail?.document?.documents_path !==
                          "" ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              class="btn btn-sm btn-primary"
                              href={this.state.detail?.document?.documents_path}
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          ) : (
                            "Tidak ada dokumen"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link
                        to="/kepegawaian/home.html?skp3k"
                        className="waves-effect"
                      >
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
